import React, { useEffect, useState } from 'react';
import THEMES from '../utils/themes';
import IH_SIGNATURE from '../utils/signature';


export default function LoginPage({ onLogin, lang, setLang, ll, thKey, setThKey }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [capsOn, setCapsOn] = useState(false);
  const rtl = lang === 'ar';
  var th = THEMES[thKey] || THEMES.dark;
  var isLightLogin = thKey === 'light';

  useEffect(function() {
    try {
      var saved = localStorage.getItem('salam_last_email');
      if (saved) setEmail(saved);
    } catch (_e) {}
  }, []);

  var checkCaps = function(e) {
    try {
      setCapsOn(!!(e && e.getModifierState && e.getModifierState('CapsLock')));
    } catch (_e) {
      setCapsOn(false);
    }
  };

  var handleSubmit = async function(e) {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    setError('');
    try {
      await onLogin(email, password);
      try { localStorage.setItem('salam_last_email', email); } catch (_e) {}
    } catch (err) {
      setError((err && err.message) ? err.message : ll.loginError);
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: th.loginBg,
      fontFamily: "'Manrope','Cairo','Segoe UI',sans-serif", padding: 20,
      direction: rtl ? 'rtl' : 'ltr', position: 'relative', overflow: 'hidden'
    }}>
      <style>{`
        @keyframes loginFadeIn {
          from { opacity: 0; transform: translateY(12px) scale(0.985); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes orbFloat {
          0% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(-12px) translateX(8px); }
          100% { transform: translateY(0px) translateX(0px); }
        }
      `}</style>

      <div style={{
        position: 'absolute', width: 460, height: 460, borderRadius: '50%',
        background: isLightLogin
          ? 'radial-gradient(circle, rgba(15,118,110,0.20), rgba(15,118,110,0.02) 68%, transparent 72%)'
          : 'radial-gradient(circle, rgba(42,161,152,0.24), rgba(42,161,152,0.02) 68%, transparent 72%)',
        top: '-140px', left: '-120px', filter: 'blur(2px)', animation: 'orbFloat 10s ease-in-out infinite'
      }} />
      <div style={{
        position: 'absolute', width: 520, height: 520, borderRadius: '50%',
        background: isLightLogin
          ? 'radial-gradient(circle, rgba(16,38,58,0.14), rgba(16,38,58,0.01) 70%, transparent 75%)'
          : 'radial-gradient(circle, rgba(16,38,58,0.24), rgba(16,38,58,0.01) 70%, transparent 75%)',
        bottom: '-180px', right: '-130px', filter: 'blur(6px)', animation: 'orbFloat 12s ease-in-out infinite'
      }} />

      <div style={{ width: '100%', maxWidth: 400 }}>
        {/* Top controls */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginBottom: 16 }}>
          <button onClick={function() { setLang(lang === 'en' ? 'ar' : 'en'); }}
            style={{ background: th.card, border: '1px solid ' + th.border, borderRadius: 6, padding: '4px 10px', color: th.sub, fontSize: 11, cursor: 'pointer' }}>
            {ll.lang}
          </button>
          <select value={thKey} onChange={function(e) { setThKey(e.target.value); }}
            style={{ background: th.card, border: '1px solid ' + th.border, borderRadius: 6, padding: '4px 8px', color: th.sub, fontSize: 11 }}>
            <option value="dark" style={{ color: '#000' }}>Dark</option>
            <option value="light" style={{ color: '#000' }}>Light</option>
            <option value="hybrid" style={{ color: '#000' }}>Hybrid</option>
          </select>
        </div>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 24, animation: 'loginFadeIn .55s ease-out' }}>
          <div style={{
            width: 96, height: 96, borderRadius: 24, margin: '0 auto 14px',
            overflow: 'hidden', background: 'linear-gradient(180deg,#ffffff,#f8fafc)', boxShadow: '0 14px 42px rgba(2,6,23,0.38)',
            border: '1px solid rgba(226,232,240,0.95)'
          }}>
            <img src="/s.png" alt="Logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 10, boxSizing: 'border-box' }}
              onError={function(e) {
                e.target.style.display = 'none';
                e.target.parentNode.style.background = 'linear-gradient(135deg,#d4af37,#a07828)';
                e.target.parentNode.style.display = 'flex';
                e.target.parentNode.style.alignItems = 'center';
                e.target.parentNode.style.justifyContent = 'center';
                e.target.parentNode.innerHTML = '<span style="font-size:28px;font-weight:800;color:white;font-family:Georgia,serif">S</span>';
              }} />
          </div>
          <h1 style={{ color: th.hText, fontSize: 32, fontWeight: 800, margin: 0, fontFamily: "'Manrope','Cairo','Segoe UI',sans-serif", letterSpacing: 0.2 }}>
            {ll.company}
          </h1>
          <p style={{ color: th.sub, fontSize: 12, marginTop: 6, letterSpacing: 0.4 }}>
            {ll.app}
          </p>
        </div>

        {/* Login Form */}
        <div style={{
          background: th.card,
          borderRadius: 18,
          padding: 28,
          border: '1px solid ' + th.border,
          boxShadow: isLightLogin ? '0 14px 38px rgba(15,23,42,0.10)' : '0 16px 60px rgba(3,6,28,0.45)',
          backdropFilter: 'blur(10px)',
          animation: 'loginFadeIn .72s ease-out'
        }}>
          <p style={{ color: th.sub, fontSize: 12, textAlign: 'center', marginBottom: 20 }}>
            {ll.login}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: th.sub, display: 'block', marginBottom: 4 }}>
                {ll.email}
              </label>
              <input type="email" value={email}
                autoFocus
                onChange={function(e) { setEmail(e.target.value); }}
                style={{
                  width: '100%', padding: '11px 14px', borderRadius: 8,
                  border: '1px solid ' + th.inpB, background: th.inp,
                  fontSize: 13, outline: 'none', color: th.inpT, boxSizing: 'border-box',
                  direction: 'ltr'
                }}
                placeholder="email@salaminv.com" />
            </div>

            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: th.sub, display: 'block', marginBottom: 4 }}>
                {ll.password}
              </label>
              <div style={{ position: 'relative' }}>
                <input type={showPassword ? 'text' : 'password'} value={password}
                  onChange={function(e) { setPassword(e.target.value); }}
                  onKeyDown={function(e) { checkCaps(e); if (e.key === 'Enter') handleSubmit(e); }}
                  onKeyUp={checkCaps}
                  style={{
                    width: '100%', padding: '11px 74px 11px 14px', borderRadius: 8,
                    border: '1px solid ' + th.inpB, background: th.inp,
                    fontSize: 13, outline: 'none', color: th.inpT, boxSizing: 'border-box',
                    direction: 'ltr'
                  }}
                  placeholder="••••••••" />
                <button
                  type="button"
                  onClick={function() { setShowPassword(!showPassword); }}
                  style={{
                    position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                    border: '1px solid ' + th.border, background: th.card, color: th.text,
                    borderRadius: 6, fontSize: 10, fontWeight: 700, padding: '4px 8px', cursor: 'pointer'
                  }}
                >
                  {showPassword ? 'HIDE' : 'SHOW'}
                </button>
              </div>
              {capsOn && (
                <div style={{ marginTop: 6, color: '#ffcf66', fontSize: 11 }}>
                  Caps Lock is on
                </div>
              )}
            </div>

            {error && (
              <div style={{
                background: 'rgba(231,76,60,0.15)', border: '1px solid rgba(231,76,60,0.3)',
                borderRadius: 6, padding: '8px 12px', fontSize: 11, color: '#e74c3c'
              }}>
                {error}
              </div>
            )}

            {!error && (
              <div style={{ color: th.sub, fontSize: 11, textAlign: 'center', marginTop: -2 }}>
                Press Enter to sign in faster
              </div>
            )}

            <button onClick={handleSubmit} disabled={loading || !email || !password}
              style={{
                width: '100%', padding: 12, borderRadius: 8, border: 'none',
                background: loading ? '#6e6e72' : 'linear-gradient(135deg,' + th.accent + ',' + th.header + ')',
                color: 'white', fontSize: 14, fontWeight: 700, cursor: loading ? 'default' : 'pointer',
                marginTop: 4, opacity: (!email || !password) ? 0.5 : 1,
                boxShadow: '0 8px 20px rgba(15,118,110,0.35)',
                letterSpacing: 0.2
              }}>
              {loading ? ll.signingIn : ll.signIn}
            </button>
          </div>
        </div>

        {/* I.H Signature */}
        <div style={{ marginTop: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
          <div style={{ flex: 1, maxWidth: 60, height: 1, background: 'linear-gradient(to right, transparent, ' + th.border + ')' }}></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src={IH_SIGNATURE} alt="I.H" style={{ height: 26, filter: isLightLogin ? 'invert(28%) sepia(22%) saturate(620%) hue-rotate(158deg) brightness(88%)' : 'invert(88%) sepia(4%) saturate(740%) hue-rotate(154deg) brightness(96%)', opacity: 0.85 }} />
            <span style={{ fontSize: 9, color: th.sub, letterSpacing: 0.5 }}>Design & Development</span>
          </div>
          <div style={{ flex: 1, maxWidth: 60, height: 1, background: 'linear-gradient(to left, transparent, ' + th.border + ')' }}></div>
        </div>
      </div>
    </div>
  );
}
